import PageLayout from "@components/PageLayout";
import { StableVault } from "@components/V2/Vault";

const StableVaultPage = () => {
  return (
    <PageLayout extraMarginTop={false}>
      <StableVault />
    </PageLayout>
  );
};

export default StableVaultPage;
